import { useMemo } from "react";
import { useAuth } from "../context/AuthContext";

export const useCommercialTreasuryPermissions = () => {
  const auth = useAuth();

  return useMemo(() => {
    if (!auth) {
      return {
        canViewTreasury: false,
        canExportTreasury: false,
        canViewTreasuryAccounts: false,
        canCreateTreasuryAccounts: false,
        canEditTreasuryAccounts: false,
        canDeleteTreasuryAccounts: false,
        canViewTreasuryMovements: false,
        canCreateTreasuryMovements: false,
        canCreateTreasuryTransfers: false,
      };
    }

    if (auth.user?.is_superadmin) {
      return {
        canViewTreasury: true,
        canExportTreasury: true,
        canViewTreasuryAccounts: true,
        canCreateTreasuryAccounts: true,
        canEditTreasuryAccounts: true,
        canDeleteTreasuryAccounts: true,
        canViewTreasuryMovements: true,
        canCreateTreasuryMovements: true,
        canCreateTreasuryTransfers: true,
      };
    }

    const hasPermission = (key) => auth.hasPermission?.(key) || false;

    return {
      canViewTreasury:
        hasPermission("Gestion Commerciale.Tresorerie.Flux.view") ||
        hasPermission("Gestion Commerciale.Tresorerie.Comptes.view"),
      canExportTreasury: hasPermission(
        "Gestion Commerciale.Tresorerie.Flux.export"
      ),
      canViewTreasuryAccounts: hasPermission(
        "Gestion Commerciale.Tresorerie.Comptes.view"
      ),
      canCreateTreasuryAccounts: hasPermission(
        "Gestion Commerciale.Tresorerie.Comptes.create"
      ),
      canEditTreasuryAccounts: hasPermission(
        "Gestion Commerciale.Tresorerie.Comptes.edit"
      ),
      canDeleteTreasuryAccounts: hasPermission(
        "Gestion Commerciale.Tresorerie.Comptes.delete"
      ),
      canViewTreasuryMovements: hasPermission(
        "Gestion Commerciale.Tresorerie.Mouvements.view"
      ),
      canCreateTreasuryMovements: hasPermission(
        "Gestion Commerciale.Tresorerie.Mouvements.create"
      ),
      canCreateTreasuryTransfers: hasPermission(
        "Gestion Commerciale.Tresorerie.Transferts.create"
      ),
    };
  }, [auth]);
};
